import React, { createContext, useContext, useState, useCallback } from 'react';

interface YearContextValue {
  selectedYear: number; // 0 = all years
  setSelectedYear: (year: number) => void;
  showArchive: boolean;
  setShowArchive: (v: boolean) => void;
}

const STORAGE_KEY = 'crm_selected_year';
const currentYear = new Date().getFullYear();

function loadYear(): number {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const n = parseInt(saved, 10);
      if (!isNaN(n) && (n === 0 || (n >= 2020 && n <= 2030))) return n;
    }
  } catch { /* ignore */ }
  return currentYear;
}

const YearContext = createContext<YearContextValue>({
  selectedYear: currentYear,
  setSelectedYear: () => {},
  showArchive: false,
  setShowArchive: () => {},
});

export const YearProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedYear, setYear] = useState<number>(loadYear);
  const [showArchive, setShowArchive] = useState(false);

  const setSelectedYear = useCallback((year: number) => {
    setYear(year);
    localStorage.setItem(STORAGE_KEY, String(year));
  }, []);

  return (
    <YearContext.Provider value={{ selectedYear, setSelectedYear, showArchive, setShowArchive }}>
      {children}
    </YearContext.Provider>
  );
};

export const useYearContext = () => useContext(YearContext);
